import React, { useRef } from 'react';

import classNames from 'classnames';

import { ReactComponent as AbsentIcon } from 'assets/icons/attendance_absent.svg';
import { ReactComponent as LateIcon } from 'assets/icons/attendance_late.svg';
import { ReactComponent as ExemptIcon } from 'assets/icons/attendance_exempt.svg';
import { ReactComponent as RemarkIcon } from 'assets/icons/attendance_remark.svg';

import './StudentGradeCell.scoped.scss';
import StyledTooltip from 'components/StyledTooltip/StyledTooltip';

import DetailsPopup from '../DetailsPopup/DetailsPopup';

interface Props {
  id: string;
  gradeItem: any;
  popoverOpened: string;

  setPopoverOpened: React.Dispatch<React.SetStateAction<string>>;
}

const StudentGradeCell: React.FC<Props> = ({ id, gradeItem, popoverOpened, setPopoverOpened }) => {
  const rootNode = useRef(null);
  const detailsOpened = id === popoverOpened;

  const handleClick = () => {
    setPopoverOpened(id);
  };

  const icons = {
    absent: <AbsentIcon />,
    late: <LateIcon />,
    exempt: <ExemptIcon />,
    remark: <RemarkIcon />,
  };
  return (
    <td
      className={classNames({
        'grades-table-grade-cell': true,
        details: detailsOpened,
        'has-grade': gradeItem && gradeItem.mark,
      })}
      onClick={handleClick}
    >
      <div
        ref={rootNode}
        className={classNames({
          content: true,
        })}
      >
        <StyledTooltip
          key={gradeItem?.type?.text || Math.random()}
          direction="up"
          tagName="div"
          content={<p>{gradeItem?.type?.text}</p>}
        >
          {icons[gradeItem?.type?.icon]}
        </StyledTooltip>
      </div>

      {detailsOpened && (
        <DetailsPopup
          gradeItem={gradeItem}
          onClose={() => {
            setPopoverOpened('');
          }}
          rootNode={rootNode}
        />
      )}
    </td>
  );
};

export default StudentGradeCell;
